import FaqBlock from '../../components/FaqBlock';
import { AppStoreIcon } from '../../components/rentAndShare/AppStoreIcon';
import { ContentTextBox } from '../../components/rentAndShare/ContentTextBox';
import { GooglePlayIcon } from '../../components/rentAndShare/GooglePlayIcon';
import { LinkApp } from '../../components/rentAndShare/LinkApp';
import { TwoFlexibleComponentBox } from '../../components/rentAndShare/TwoFlexibleComponentBox';
import { VideoClip } from '../../components/rentAndShare/VideoClip';
import Snippet from '../../components/Snippet';
import KIAImage from '../../components/ui/image/KIAImage';

const RentAndShareApp = () => {
  return (
    <main>
      <VideoClip
        title="Kia Drive"
        subTitle="Hyr & Dela"
        autoplay
        src="https://kia-afonso-storage.b-cdn.net/filmer/HyrDela-Hero-Clean-EV3-appsida.mp4"
      />
      <div className="w-full max-w-screen-kia mx-auto">
        <TwoFlexibleComponentBox
          firstComponent={
            <ContentTextBox
              className="max-w-[650px]"
              title="Kia Drive"
              description="Har du blivit inbjuden att använda vår mobilitetstjänst Kia Drive? Grattis! Det är en enkel och smart tjänst där flera användare kan dela på en eller flera bilar. Du bokar, låser upp och betalar för ditt användande direkt i vår app. Så här kommer du i gång."
            >
              <div className="flex gap-4 mt-auto">
                <LinkApp
                  text="Google Play"
                  Icon={GooglePlayIcon}
                  href="https://play.google.com/store/apps/details?id=com.ridecell.massiv.kangaroo.prod&hl=en"
                  target="_blank"
                />
                <LinkApp
                  text="App Store"
                  Icon={AppStoreIcon}
                  href="https://apps.apple.com/se/app/hyr-dela/id1658798260"
                  target="_blank"
                />
              </div>
            </ContentTextBox>
          }
          secondComponent={
            <KIAImage
              src="https://www.kia.com/content/dam/kwcms/kme/se/sv/assets/campaigns/hyr-och-dela/Appsida-bild-man.jpg"
              alt="KIA Car"
              sizes="(max-width: 768px) 100vw, 50vw"
              className="max-h-[450px] object-cover object-center"
            />
          }
          mobilFirstComponentOnTop={true}
          desktopFirstComponentFirst={false}
        />
        <TwoFlexibleComponentBox
          firstComponent={
            <ContentTextBox
              title="Så fungerar appen Kia Drive"
              listItems={[
                {
                  title: 'Ladda ner appen Kia Drive.',
                  text: 'Den finns för både Apple och Android.',
                },
                {
                  title: 'Skapa ett konto.',
                  text: 'Lägg till betalningsinformation och välj upphämtningsställe. Upphämtningsstället är oftast adressen till företaget som du ansluter till.',
                },
                {
                  title: 'Hitta alla bokningsbara bilar.',
                  text: 'Boka från en timme och uppåt.',
                },
                {
                  title: 'Använd appen för att låsa upp och starta bilen.',
                  text: 'Vill du korta eller förlänga din hyrestid gör du det direkt i appen.',
                },
                {
                  title: 'Lämna tillbaka bilen där du hämtade den.',
                  text: 'Avsluta och betala via appen!',
                },
              ]}
            />
          }
          secondComponent={
            <KIAImage
              src="https://kia-afonso-storage.b-cdn.net/Appsida-bild-ev3.jpg"
              alt="KIA Car"
              sizes="(max-width: 768px) 100vw, 50vw"
              className="lg:min-h-[550px] max-h-[600px] object-cover object-center"
            />
          }
          mobilFirstComponentOnTop={true}
          desktopFirstComponentFirst={true}
        />
        <FaqBlock
          className="bg-dark-blue"
          questions={[
            {
              q: 'Hur laddar jag bilen?',
              a: 'Har ni inte laddstationer på plats hjälper Kia-återförsäljaren er med en lösning som passar era behov.',
            },
            {
              q: 'Hur får jag tillgång till bilen?',
              a: "Din mobil är nyckeln till bilen. Några minuter innan din hyresperiod börjar så skickas ett sms till det mobilnummer du uppgett, och din bil aktiveras samtidigt i Kia Drive-appen. Du öppnar bilen genom att trycka på 'Lås upp & starta' i appen, och du har sedan två minuter på dig att starta bilen. Hinner du inte starta bilen trycker du på knappen 'Starta och lås upp' i appen igen, och får då två nya minuter på dig att starta bilen.",
            },
            {
              q: 'Vad händer om jag krockar?',
              a: "Bilen är fullt försäkrad. Om olyckan skulle vara framme gäller självrisk enligt hyresavtalet. <a href='https://www.kia.com/se/kopa/hyr-och-dela/support/forsakring'>Läs mer</a>",
            },
            {
              q: 'Vem tar hand om bilen?',
              a: "Ni kan välja om ni som företag tar ansvar för allt som rör bilen, precis som en traditionell tjänstebil, eller om ni önskar en fullservicelösning. Prata med er <a href='https://www.kia.com/se/sok-aterforsaljare-verkstad/#/'>Kia-återförsäljare</a> för att hitta en passande lösning för era behov.",
            },
          ]}
          title="Vanliga frågor och svar"
        />
        <VideoClip
          autoplay
          cropMobile={false}
          src="https://kia-afonso-storage.b-cdn.net/filmer/Hyrdela-Appfilm-v2.mp4"
        />
        <Snippet page="rent-app" />
      </div>
    </main>
  );
};
export default RentAndShareApp;
